module.exports = __webpack_public_path__ + "static/img/25.0d32f43c.png";